module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-card",
    class: {
      'message-card--open': _vm.currentMessageViewOption === 0,
      'message-card--error': _vm.showValidationError
    }
  }, [_c('div', {
    staticClass: "message-card__header",
    attrs: {
      "role": "button",
      "tabindex": "0",
      "aria-expanded": _vm.currentMessageViewOption === 0 ? 'true' : 'false'
    },
    on: {
      "click": _vm.toggleView,
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.toggleView.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.toggleView.apply(null, arguments)
      }]
    }
  }, [_c('i', {
    staticClass: "fa fa-bars message-card__grip",
    attrs: {
      "title": "Drag to reorder",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down message-card__chevron",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "message-card__title"
  }, [_vm._v(_vm._s('Message ' + (_vm.index + 1)))]), _vm._v(" "), (_vm.showValidationError) ? _c('span', {
    staticClass: "message-card__badge"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Needs a fix")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "message-card__actions",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('button', {
    staticClass: "message-action message-action--primary",
    attrs: {
      "type": "button",
      "title": "Translate the Global English text into the switched-on languages"
    },
    on: {
      "click": function($event) {
        return _vm.translate()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-language",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Translate\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "message-action",
    attrs: {
      "type": "button",
      "title": "Switch off translation for every language"
    },
    on: {
      "click": function($event) {
        return _vm.lockAll()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Lock All\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "message-action",
    attrs: {
      "type": "button",
      "title": "Switch on translation for every language"
    },
    on: {
      "click": function($event) {
        return _vm.unlockAll()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-unlock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Unlock All\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "message-action message-action--icon message-action--danger",
    attrs: {
      "type": "button",
      "title": "Delete message"
    },
    on: {
      "click": function($event) {
        return _vm.deleteMessage(_vm.index)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    class: [_vm.messageViewClass, _vm.messageStyleClass],
    attrs: {
      "id": 'content-message-' + _vm.index
    }
  }, _vm._l((_vm.displayMessage), function(text, country) {
    return _c('div', {
      key: country,
      staticClass: "message-country-group"
    }, [(Object.keys(text).length) ? _c('table', {
      staticClass: "fixed-table"
    }, [_vm._l((text), function(messageRow, language, iSub) {
      return _c('tr', {
        key: language
      }, [(iSub === 0) ? _c('td', {
        staticClass: "message-country",
        attrs: {
          "rowspan": Object.keys(text).length
        }
      }, [_c('span', {
        staticClass: "message-country__name"
      }, [_vm._v(_vm._s(_vm.getCountryName(country)))])]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "message-language"
      }, [_c('span', {
        staticClass: "message-language__code"
      }, [_vm._v(_vm._s(language))]), _vm._v(" "), (_vm.getCountryName(country) !== 'Global' && _vm.translateSwitch[country]) ? _c('label', {
        staticClass: "switch",
        attrs: {
          "title": "Include this language when translating"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.translateSwitch[country][language]),
          expression: "translateSwitch[country][language]"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(_vm.translateSwitch[country][language]) ? _vm._i(_vm.translateSwitch[country][language], null) > -1 : (_vm.translateSwitch[country][language])
        },
        on: {
          "change": [function($event) {
            var $$a = _vm.translateSwitch[country][language],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(_vm.translateSwitch[country], language, $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(_vm.translateSwitch[country], language, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(_vm.translateSwitch[country], language, $$c)
            }
          }, function($event) {
            _vm.emitUpdatedMessage = true
          }]
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "slider round"
      })]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "clear-translation"
      }, [_c('button', {
        staticClass: "message-erase",
        attrs: {
          "type": "button",
          "title": "Erase this translation"
        },
        on: {
          "click": function($event) {
            return _vm.eraseTranslation(country, language)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-times-circle",
        attrs: {
          "aria-hidden": "true"
        }
      })])]), _vm._v(" "), _c('td', [_c('textarea-autosize', {
        staticClass: "form-control message-text",
        staticStyle: {
          "min-height": "50px"
        },
        attrs: {
          "value": messageRow,
          "placeholder": "message"
        },
        model: {
          value: (_vm.displayMessage[country][language]),
          callback: function($$v) {
            _vm.$set(_vm.displayMessage[country], language, $$v)
          },
          expression: "displayMessage[country][language]"
        }
      })], 1), _vm._v(" "), (_vm.showValidationError && (_vm.errorCountry.includes(country)) && (_vm.errorLanguage.includes(language))) ? _c('td', {
        staticClass: "message-error-icon"
      }, [_c('i', {
        staticClass: "fa fa-exclamation-circle",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _vm._e()])
    }), _vm._v(" "), (_vm.showValidationError && (_vm.errorCountry.includes(country))) ? _c('tr', [_c('td', {
      staticClass: "text-red message-error-text",
      attrs: {
        "colspan": 4
      }
    }, [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()], 2) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0cf9676e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/convoMessage.vue
// module id = BFUD
// module chunks = 1